import React from 'react';
import { Clock, Users, BookOpen } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useGuideStats } from '@/hooks/useGuides';
import StatsCard from './StatsCard';

const GuidesStatsCards: React.FC = () => {
  const { t } = useTranslation('admin');
  const { data: statsData, isLoading, error } = useGuideStats();
  const stats = statsData?.data;

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-4 animate-pulse"
          >
            <div className="flex items-center space-x-3">
              <div className="p-2 bg-gray-200 dark:bg-gray-700 rounded-lg w-12 h-12"></div>
              <div className="flex-1">
                <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-24 mb-2"></div>
                <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded w-16"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-red-50 dark:bg-red-900/20 rounded-lg border border-red-200 dark:border-red-800 p-4">
          <p className="text-sm text-red-600 dark:text-red-400">{t('guides.table.error.message')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <StatsCard
        Icon={<BookOpen className="w-5 h-5 text-blue-600 dark:text-blue-400" />}
        label={t('guides.stats.totalGuides')}
        value={stats?.totalGuides || 0}
      />
      <StatsCard
        Icon={<Users className="w-5 h-5 text-green-600 dark:text-green-400" />}
        label={t('guides.stats.published')}
        value={stats?.totalPublished || 0}
      />
      <StatsCard
        Icon={<Clock className="w-5 h-5 text-yellow-600 dark:text-yellow-400" />}
        label={t('guides.stats.drafts')}
        value={stats?.totalDrafts || 0}
      />
    </div>
  );
};

export default GuidesStatsCards;
